/** Módulo nativo sem equivalente na web: tudo vira função vazia/valor nulo via Proxy. */
const noop = () => undefined;
const handler: ProxyHandler<object> = {
  get: (_t, prop) => {
    if (prop === '__esModule') return true;
    if (prop === 'default') return proxy;
    if (prop === 'then') return undefined;
    return proxy;
  },
  apply: () => undefined,
  construct: () => ({}),
};
const proxy: any = new Proxy(noop, handler);
export default proxy;
export const Platform = { OS: 'web' };
